import { ImportantContactType } from '@lmc/ts-common'
import { Route } from 'react-router-dom'
import { ResidentImportantPeopleScreen } from 'screens/Residents/screens/ResidentImportantPeopleScreens/ResidentimportantPeopleScreen'
import GPContactScreen from 'screens/Residents/screens/ResidentImportantPeopleScreens/screens/GPContactScreen'
import ResidentPersonalContactCreateScreen from 'screens/Residents/screens/ResidentImportantPeopleScreens/screens/PersonalContactCreateScreen'
import ResidentPersonalContactUpdateScreen from 'screens/Residents/screens/ResidentImportantPeopleScreens/screens/PersonalContactUpdateScreen'
import ProfessionalContactCreateScreen from 'screens/Residents/screens/ResidentImportantPeopleScreens/screens/ProfessionalContactCreateScreen'
import ProfessionalContactUpdateScreen from 'screens/Residents/screens/ResidentImportantPeopleScreens/screens/ProfessionalContactUpdateScreen'
import { ID } from '../utils'

export const importantPeopleRoutes = (
  <Route path={`${ID}/important-people`}>
    <Route index path="" element={<ResidentImportantPeopleScreen />} />
    <Route
      path="add-personal"
      element={<ResidentPersonalContactCreateScreen />}
    />
    <Route
      path={`add-${ImportantContactType.professional}`}
      element={<ProfessionalContactCreateScreen />}
    />
    <Route path="add-gp" />
    <Route path=":index">
      <Route
        path="edit-personal"
        element={<ResidentPersonalContactUpdateScreen />}
      />
      <Route
        path={`edit-${ImportantContactType.professional}`}
        element={<ProfessionalContactUpdateScreen />}
      />
    </Route>
    <Route path="edit-gp" element={<GPContactScreen />} />
  </Route>
)
